import { LegalLayout } from "./components/legalLayout";
import { DATA_RETENTION } from "./content/dataRetention";

/** /retencao-de-dados — prazos de guarda de cada tipo de dado. */
export const RetencaoDeDados = () => <LegalLayout document={DATA_RETENTION} />;
